import { useState, useEffect } from 'react';

const apiUrl = process.env.REACT_APP_AIRTABLE_PROPERTIES_URL;
const apiKey = process.env.REACT_APP_AIRTABLE_API_KEY;

export default function useProperty(id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;
    const fetchProperty = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${apiUrl}/${id}`, {
          headers: { Authorization: `Bearer ${apiKey}` },
        });
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError(err.message || 'Failed fetching property');
      } finally {
        setLoading(false);
      }
    };
    fetchProperty();
  }, [id]);

  return { data, loading, error };
}
